<template>
    <div>
        <v-row>
            <v-col sm="6" md="3" class="pt-4 pb-0 py-md-0">
                <v-text-field
                        :label="$t('quantity')"
                        type="number"
                        v-model="quantity"
                        class="max-height input-mobile-text"
                        color="orange lighten-2"
                        outlined
                        @input="valueChange"
                        min="0"
                        dense
                ></v-text-field>
            </v-col>
            <v-col sm="6" md="9" class="py-0">
                <v-row>
                    <v-col cols="12" class="pt-4 pb-0 py-md-0 d-flex flex-column align-end flex-md-row align-md-start justify-md-space-between">
                        <div class="text-line-through d-flex justify-end" v-if="totalDiscount">
                            <span :class="priceCss"> {{priceString(calculatedPrice)}} {{ currency.cyrName.toLowerCase() }}</span>
                        </div>
                        <div v-if="totalDiscount" class="font-weight-bold teal--text d-flex justify-end">{{ $t('discount') }}: {{ totalDiscount }}%</div>
                        <div class="min-text">
                            <div v-if="totalDiscount" class="font-weight-bold d-flex justify-end div1">
                                <span>{{priceString(discountPrice)}} {{ currency.cyrName.toLowerCase() }}</span>
                            </div>
                            <div v-else class="font-weight-bold d-flex justify-end div2">
                                <span>{{priceString(calculatedPrice)}} {{ currency.cyrName.toLowerCase() }}</span>
                            </div>
                        </div>
                    </v-col>
                </v-row>
                <v-row class="hidden-sm-and-down">
                    <v-col cols="12" class="pt-0 pb-2 min-text">
                        <span class="grey-text lighten-1 body-2">{{orderQuantityValue}}</span>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="hidden-sm-and-up">
            <v-col cols="12" class="pt-0 pb-2 min-text">
                <span class="grey-text lighten-1 body-2">{{orderQuantityValue}}</span>
            </v-col>
        </v-row>
    </div>
</template>

<script>
    import OrderBackup from "../../../../app-front/mixins/OrderBackup"
    import Auth from "../../../../app-front/mixins/Auth";
    import numberFormat from "../../../../utils/numberFormat";

    export default {
        name: "QuantitySelect",
        props: ['id', 'orderData', 'price', 'discountPrice', 'totalDiscount', 'sellerId'],
        mixins: [OrderBackup, Auth],
        data() {
            return {
                calculatedPrice: null,
                quantity: null
            }
        },
        computed: {
            currency() {
                return this.$store.getters.currencies[0]
            },
            basketItems() {
                return (this.isUserLoggedIn) ? this.$store.getters.basketItems : this.$store.getters.noLoginBasket.map(item=>{
                    return {
                        productId: item.id,
                        quantity: item.quantity,
                    }
                });
            },
            orderQuantityValue() {
                const quantity = this.quantity ? parseFloat(this.quantity) : null;

                if (!quantity) return null;

                const unitName = this.orderData.unitName.toLowerCase() || null;
                const minValue = this.orderData.minValue || null;
                const value = this.orderData.value || null;
                let str = this.$t('total');

                let ultimatePrice = parseFloat(`${value * quantity * minValue}`).toLocaleString();
                let usualPrice = parseFloat(`${value * quantity}`).toLocaleString();

                if (minValue) {
                    str += `: ${ultimatePrice} ${unitName}`;
                } else {
                    str += `: ${usualPrice} ${unitName}`;
                }

                return str;
            },
            priceCss() {
                return this.discountPrice ? 'text-decoration-line-through' : '';
            },
        },
        methods: {
            valueChange() {
                if (!this.price) {
                    this.calculatedPrice = null;
                    this.$emit('value-change', {quantity: this.quantity, price: null});

                    return false;
                }

                let price = this.price * this.quantity * this.orderData.value;

                if (this.orderData.minValue) {
                    price *= this.orderData.minValue;
                }

                this.calculatedPrice = parseFloat(price.toFixed(2));
                this.$emit('value-change', {price: this.calculatedPrice, quantity: this.quantity});
            },
            // priceString(price) {
            //     return price ? parseFloat(price).toLocaleString() : 0;
            // },
            priceString(price) {
                return price ? numberFormat(price, 2, '.', ' ') : 0;
            },
            setInitial() {
                const item = this.basketItems.find(item=> item.productId == this.id)
                const defaultQuantity = (item && item.quantity !== undefined) ? item.quantity :  1;

                if(!this.sellerId || !this.id) return false;

                const backupSeller = this.backupGet().find(item => item.sellerID === this.sellerId);

                if(!backupSeller) {
                    this.setInitialQuantity(defaultQuantity);

                    return;
                }

                const backupProduct = backupSeller.products.find(item => item.id === this.id);

                if(!backupProduct) {
                    this.setInitialQuantity(defaultQuantity);

                    return;
                }

                this.setInitialQuantity(backupProduct.quantity);
            },
            setInitialQuantity(quantity) {
                this.quantity = quantity;
                this.valueChange();
            },
        },
        mounted() {
            this.setInitial();
        }
    }
</script>

<style scoped>
    .max-height {
        max-height: 45px !important;
    }

    @media all and (max-width: 800px) {
        .input-mobile-text {
            font-size: 12px;
        }
    }
</style>
